<form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">

    <div class="form-group">

        <label *ngIf="label" for="{{fieldId}}">
            <span class="star" *ngIf="required">*</span> {{ label }}
        </label>

        <div class="ff-group">

            <ng-select class="custom-lang" placeholder="{{ 'CERTIFICATE.CHOOSE_YOUR_VALUE' | translate }}" bindLabel="value"
                bindValue="code2" formControlName="currentLang" [items]="languages" [dropdownPosition]="'bottom'"
                [clearable]="false" appendTo="body">
            </ng-select>

            <!-- <select class="custom-select" formControlName="currentLang">
                <option *ngFor="let language of languages" [value]="language.code2">{{ language.value }}</option>
            </select> -->

            <textarea class="form-control" [placeholder]="placeHolder" [ngClass]="{'clear-field': clearField}"
                formControlName="field" [name]="fieldName" [id]="fieldId" [readonly]="readonly"></textarea>

                <div *ngIf="clearField && form.get('field').value" class="input-group-append">
                    <button class="btn btn-none" type="button" (click)="clearingField()" placement="left"
                    tooltipClass="clue-name" ngbTooltip="{{ 'CLEAN_CURRENT_LANGUAGE' | translate }}" tooltipClass="clue-name" [closeDelay]="300">
                        <svg-icon src="/assets/images/icons/close-circle.svg" [stretch]="true"
                            [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>

        </div>

        <small *ngIf="hint" class="form-text text-muted">{{ hint }}</small>

        <div *ngIf="errorMessages">
            <div *ngFor="let item of errorMessages">
                <div class="text-error" *ngIf="validation('field', item.type)">
                    {{ item.message | translate: item.options }}
                </div>
            </div>
        </div>

        <div formArrayName="list">
            <div *ngFor="let elem of form.get('list')['controls']; let i = index;">
                <div [formGroupName]="i">

                    <div *ngIf="errorMessagesForLang">
                        <div *ngFor="let item of errorMessagesForLang">
                            <div class="text-error" *ngIf="validation(['list', i, 'value'], item.type)">
                                {{ item.message | translate: { fieldName: getLangComparison(languages[i].value) } }}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>

</form>